import {EventSubscriber, HasEventName} from "@/modules/base/events";
import {inject, injectable} from "inversify";
import {AfterCreateGameEvent} from "@/modules/base/events/AfterCreateGameEvent";
import {FriendlyCompetition, KODivision} from "@/modules/competitions/entity";
import {ConfigRepository} from "@/modules/base/services/ConfigRepository";

@injectable()
export class FriendlyEventSubscriber implements EventSubscriber {
  constructor(
    @inject(ConfigRepository) protected configRepository: ConfigRepository,
  ) {}

  priority(): number {
    return 0;
  }

  init(): { event: HasEventName; callback: (event: any) => void }[] {
    return [
      {event: AfterCreateGameEvent, callback: this.onAfterCreateGameEvent},
    ];
  }

  async onAfterCreateGameEvent(event: AfterCreateGameEvent): Promise<void> {
    if (!this.configRepository.get('debug')) {
      return;
    }

    const competition = new FriendlyCompetition();
    competition.name = translator.t('friendlies');
    await competition.save();

    const division = new KODivision();
    division.name = translator.t('friendlies');
    division.competition = competition;
    await division.save();
  }
}